var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAvailable
    ? _c(
        "div",
        {
          staticClass: "tooltip-vue",
          class: _vm.customClass,
          style: _vm.tooltipStyle,
          attrs: { id: "asd" },
          on: {
            mouseenter: _vm.handleMouseEnter,
            mouseleave: _vm.handleMouseLeave
          }
        },
        [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.localText) } }),
          _vm._v(" "),
          _c("div", { staticClass: "arrow arrow--top-right" })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }